import React, { useState, useEffect, useRef } from 'react';
import api from '../api/client';

const Dropdown = ({ options, selected, onChange, useFixed = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [dropStyle, setDropStyle] = useState({});
    const triggerRef = useRef(null);

    const handleSelect = (option) => {
        onChange(option);
        setIsOpen(false);
        setSearchTerm('');
    };

    const handleToggle = () => {
        if (!isOpen && useFixed && triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            const minWidth = Math.max(rect.width, 220);
            let left = rect.left;
            if (left + minWidth > window.innerWidth - 8) left = Math.max(8, window.innerWidth - minWidth - 8);
            setDropStyle({
                position: 'fixed',
                top: rect.bottom + 2,
                left,
                width: minWidth,
                zIndex: 2000,
            });
        }
        setIsOpen(o => !o);
    };

    // Close on outside click
    useEffect(() => {
        if (!isOpen) return;
        const handler = (e) => {
            if (triggerRef.current && !triggerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [isOpen]);

    const filteredOptions = options.filter(option =>
        (option.label ?? '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="select" ref={triggerRef}>
            <div className="slct" onClick={handleToggle}>
                {selected ? selected.label : 'None Selected >'}
            </div>
            {isOpen && (
                <div className="drop open" style={useFixed ? dropStyle : {}}>
                    <input
                        type="text"
                        className="drop__search"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        autoFocus
                    />
                    <ul className="drop__list">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((option) => (
                                <li key={option.value} onClick={() => handleSelect(option)}>
                                    {option.label}
                                </li>
                            ))
                        ) : (
                            <li className="drop__no-options">No options found</li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

const SelectBox = ({ tableName, displayField, updateField, displayPrefix, selectedValue, onChange, useFixed = false }) => {
    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const response = await api.get(`/api/options/${tableName}`);
                // console.log('Response data:', response.data);
                
                // Проверяем, что response.data и response.data.items существуют и являются массивом
                if (response.data && Array.isArray(response.data.items)) {
                    const optionList = response.data.items.map((item, index) => {
                        // console.log(`Item ${index} - updateField: ${item[updateField]}, displayField: ${item[displayField]}`);
                        const name = item[displayField] ?? item[updateField] ?? '';
                        const prefix = displayPrefix && item[displayPrefix] ? item[displayPrefix] : null;
                        return {
                            value: item[updateField],
                            label: prefix ? `${prefix} — ${name}` : name,
                        };
                    });
    
                    // console.log('Option list:', optionList);
                    setOptions(optionList);
    
                    const initialSelected = optionList.find(option => option.value == selectedValue);
                    // console.log('Initial selected option:', initialSelected);
                    setSelectedOption(initialSelected || null);
                } else {
                    // console.warn('No valid items found in the response');
                    setOptions([]); // Устанавливаем пустой массив, если данные некорректны
                }
            } catch (error) {
                // console.error('Error fetching options:', error);
                setOptions([]); // Устанавливаем пустой массив при ошибке
            }
        };
    
        fetchOptions();
    }, [tableName, displayField, updateField, selectedValue]);
    
    
    

    useEffect(() => {
        const initialSelected = options.find(option => option.value == selectedValue); // Используем ==
        // console.log('Re-evaluating initial selected option:', initialSelected);
        setSelectedOption(initialSelected || null);
    }, [options, selectedValue]);

    const handleOptionChange = (option) => {
        setSelectedOption(option);
        onChange(option.value);
    };

    return (
        <Dropdown options={options} selected={selectedOption} onChange={handleOptionChange} useFixed={useFixed} />
    );
};

export default SelectBox;
